import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import { ProgressTrackerProps } from '.';

const useStyles = makeStyles(() =>
  createStyles({
    completed: {
      color: '#43936F !important',
    },
  }),
);

const DesktopProgressTracker = ({ steps }: ProgressTrackerProps) => {
  const classes = useStyles();
  return (
    <Stepper
      data-testid="desktop-progress-tracker"
      alternativeLabel
      style={{ background: 'transparent' }}
    >
      {steps.map((step, index) => {
        return (
          <Step
            key={index}
            data-testid={`desktop-progress-tracker-step${index}`}
            active={step.isActive}
            completed={step.isComplete}
          >
            <StepLabel
              StepIconProps={{
                classes: {
                  completed: classes.completed,
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default DesktopProgressTracker;
